export const SET_COMMENTS_VISIBLE = 'SET_COMMENTS_VISIBLE'
export const SET_COMMENTS_META_DATA = 'SET_COMMENTS_META_DATA'

export function setCommentsVisible (value) {
  return {
    type: SET_COMMENTS_VISIBLE,
    payload: value,
  }
}

export function refreshComments (options) {
  const {
    contentId, metadata, visible = true,
  } = options
  return function refreshCommentsThunk (dispatch) {
    dispatch(setCommentsMetaData(contentId, metadata, visible))
  }
}

export function setCommentsMetaData (
  contentId,
  metadata,
  visible = true,
) {
  return {
    type: SET_COMMENTS_META_DATA,
    payload: { contentId, metadata, visible },
  }
}
